<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-card outlined>
          <!-- Titre principal -->
          <v-card-title>
            <h1 class="text-h5">Ajout d'une problématique</h1>
          </v-card-title>

          <!-- Formulaire -->
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <!-- Titre -->
              <v-text-field v-model="form.title" label="Titre" outlined dense required></v-text-field>

              <!-- Description -->
              <v-textarea v-model="form.description" label="Description" outlined dense required></v-textarea>
            </v-card-text>

            <!-- Boutons -->
            <v-card-actions class="justify-end">
              <v-btn text color="primary" @click="stopCreation">Annuler</v-btn>
              <v-btn color="primary" type="submit" elevation="2">Créer</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "",
        description: "",
      },
      durationMenu: false,
    }
  },
  methods: {
    submitForm() {
      console.log("Form data", this.form)

      // Call the store action to create an EatingExperience
      this.$store
        .dispatch("CreateConcerns", { payload: this.form })
        .then(() => {
          console.log("Issue created successfully")
          this.$router.push({ name: "ConcernsPage" }) // Redirect to home page or another relevant page
        })
        .catch((error) => {
          console.error("Error during issue creation:", error)
          this.$store.dispatch("notifyServerError") // Notify on server error
        })
    },
    clearForm() {
      this.form = {
        title: "",
        description: "",
      }
    },
    stopCreation() {
      this.clearForm()
      this.$router.push({ name: "ConcernsPage" })
    },
  },
}
</script>

<style scoped>
.v-container {
  max-width: 800px;
  margin: auto;
}

.v-card-title {
  justify-content: center;
  font-weight: bold;
}

.v-card-actions {
  padding: 16px;
}
</style>
